import { render, staticRenderFns } from "./Trabajos.vue?vue&type=template&id=4bcf455a&scoped=true&"
import script from "./Trabajos.vue?vue&type=script&lang=js&"
export * from "./Trabajos.vue?vue&type=script&lang=js&"
import style0 from "./Trabajos.vue?vue&type=style&index=0&id=4bcf455a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcf455a",
  null
  
)

export default component.exports